import React from "react";
import styles from "./ArenaUserDashboard.module.css";

import foot from "../../dasboard-component/images/football.png";
import basket from "../../dasboard-component/images/basketball.webp";
import carrom from "../../dasboard-component/images/carrom.png";
import tabletennis from "../../dasboard-component/images/tabletennis.webp";
import badminton from "../../dasboard-component/images/badminton.png";
import boxing from "../../dasboard-component/images/boxing.png";
import chess from "../../dasboard-component/images/chess.png";
import cycling from "../../dasboard-component/images/cycling.png";
import golf from "../../dasboard-component/images/golf.png";
import gym from "../../dasboard-component/images/gym.webp";
import hockey from "../../dasboard-component/images/hockey.webp";
import horsing from "../../dasboard-component/images/horsing.png";
import karate from "../../dasboard-component/images/karate.png";
import biking from "../../dasboard-component/images/biking.png";
// import nutritionist from "../../dasboard-component/images/nutritionist.png";
import runner from "../../dasboard-component/images/runner.png";
import swimmer from "../../dasboard-component/images/swimmer.webp";
import skating from "../../dasboard-component/images/skating.png";
import boat from "../../dasboard-component/images/boat.png";
import tennis from "../../dasboard-component/images/tennis.jpg";
import padeltennis from "../../dasboard-component/images/padeltennis.png";
import volleyball from "../../dasboard-component/images/volleyball.webp";

export const sportIcons = {
  badminton: badminton,
  basketball: basket,
  boxing: boxing,
  carrom: carrom,
  chess: chess,
  cycling: cycling,
  football: foot,
  futsal: foot,
  golf: golf,
  gym: gym,
  hockey: hockey,
  "horse sports": horsing,
  jujutsu: karate,
  karate: karate,
  "lawn tennis": tabletennis,
  mma: boxing,
  "motor sports": biking,
  nutritionist: biking,
  "running / hiking/ rock climbing": runner,
  skating: skating,
  snooker: swimmer,
  swimming: swimmer,
  "table tennis": tabletennis,
  "volley ball": basket,
  yachting: boat,
  "padel tennis": padeltennis,
  tennis: tennis,
  volleyball: volleyball,
};

const SportSelection = ({ arena, onSportSelect }) => {
  if (arena.error) {
    return (
      <>
        {/* <h2>{arena.name}</h2> */}
        <p className={styles.errorMessage}>{arena.error}</p>
      </>
    );
  }

  if (!arena.sports || arena.sports.length === 0) {
    return (
      <>
        {/* <h2>{arena.name}</h2> */}
        <p className={styles.errorMessage}>
          No sports available for this arena.
        </p>
      </>
    );
  }

  return (
    <>
      {/* <h2>{arena.name}</h2> */}
      <div className={styles.sportsGrid}>
        {arena.sports.map((sport) => {
          const sportKey = sport.sport_name.toLowerCase();
          const icon = sportIcons[sportKey];

          return (
            <div
              key={`${sport.facility_id}-${sport.sport_name}`}
              className={styles.sportItem}
              onClick={() => onSportSelect(sport)}
            >
              <img src={icon} alt="fo" className={styles.sportIcon} />
              <span className={styles.sportLabel}>{sport.sport_name}</span>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SportSelection;
